
@if (show) {
  <div>
    <p>
      test table works! id = {{id}}
    </p>
  </div>
}
